import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormUsuarioFlujo from "../Components/FormUsuarioFlujo";
import BotonGerericoSalir from "app/modules/shared/containers/BotonGerericoSalir";
import BotonSalirLimiarStorageUsuario from "../../AsignarLocalUsuario/Containers/BotonSalirLimpiarStorageUsuario";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DetalleInformacionUsuario = ({ idUsuario, usuario, identificacion }) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    console.log({ idUsuario });
    console.log({ usuario });
    console.log({ identificacion });
  }, []);

  if (usuario.usuario === null) {
    return (
      <>
        <BotonGerericoSalir />
        <h2>Usuario No Existe!!</h2>
      </>
    );
  }

  return (
    <>
      <BotonSalirLimiarStorageUsuario />
      <FormUsuarioFlujo idUsuario={idUsuario} usuario={usuario} />
    </>
  );
};

export default DetalleInformacionUsuario;
